import { render } from "./Local.vue?vue&type=template&id=3ab62288"
import script from "./Local.vue?vue&type=script&lang=js"
export * from "./Local.vue?vue&type=script&lang=js"

import "./Local.vue?vue&type=style&index=0&id=3ab62288&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__